module.exports = __webpack_public_path__ + "static/media/zdislava.835e2eaa.jpg";